import { deepMerge } from '@gofranz/common';
import { commonResources, libraryI18n } from '@gofranz/common-components';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import docs translation files
import arDocs from './locales/ar-docs.json';
// Import integrations translation files
import arIntegrations from './locales/ar-integrations.json';
// Import formshive-specific translation files
import arUnique from './locales/ar-unique.json';
import deDocs from './locales/de-docs.json';
import deIntegrations from './locales/de-integrations.json';
import deUnique from './locales/de-unique.json';
import enDocs from './locales/en-docs.json';
import enIntegrations from './locales/en-integrations.json';
// App-specific integration page strings (formshive.integrations.*).
// Other locales fall back to English until a translator gets to them.
import enIntegrationsApp from './locales/en-integrations-app.json';
import enUnique from './locales/en-unique.json';
import esDocs from './locales/es-docs.json';
import esIntegrations from './locales/es-integrations.json';
import esUnique from './locales/es-unique.json';
import frDocs from './locales/fr-docs.json';
import frIntegrations from './locales/fr-integrations.json';
import frUnique from './locales/fr-unique.json';
import ptDocs from './locales/pt-docs.json';
import ptIntegrations from './locales/pt-integrations.json';
import ptUnique from './locales/pt-unique.json';
import thDocs from './locales/th-docs.json';
import thIntegrations from './locales/th-integrations.json';
import thUnique from './locales/th-unique.json';
import zhDocs from './locales/zh-docs.json';
import zhIntegrations from './locales/zh-integrations.json';
import zhUnique from './locales/zh-unique.json';

// Formshive-specific resources merged with common translations.
// App components need access to common translations (glob_navigation, glob_footer, etc.).
//
// IMPORTANT: use deepMerge, not spread. Several files (e.g. en-integrations.json)
// have a top-level `integrations` object that collides with the shared
// `commonResources.*.integrations` subtree. Shallow spread would silently replace
// the entire shared subtree and the UI would render raw `integrations.form.*` keys.
const resources = {
  en: {
    translation: deepMerge(commonResources.en, enUnique, enDocs, enIntegrations, enIntegrationsApp),
  },
  de: {
    translation: deepMerge(commonResources.de, deUnique, deDocs, deIntegrations, enIntegrationsApp),
  },
  es: {
    translation: deepMerge(commonResources.es, esUnique, esDocs, esIntegrations, enIntegrationsApp),
  },
  fr: {
    translation: deepMerge(commonResources.fr, frUnique, frDocs, frIntegrations, enIntegrationsApp),
  },
  pt: {
    translation: deepMerge(commonResources.pt, ptUnique, ptDocs, ptIntegrations, enIntegrationsApp),
  },
  zh: {
    translation: deepMerge(commonResources.zh, zhUnique, zhDocs, zhIntegrations, enIntegrationsApp),
  },
  th: {
    translation: deepMerge(commonResources.th, thUnique, thDocs, thIntegrations, enIntegrationsApp),
  },
  ar: {
    translation: deepMerge(commonResources.ar, arUnique, arDocs, arIntegrations, enIntegrationsApp),
  },
};

// Initialize i18n instance for formshive
// Apps don't use LanguageDetector - they use synchronous init + detectAndSetLanguage in App.tsx
export const i18nInitPromise = i18n.use(initReactI18next).init({
  resources,
  lng:
    typeof window !== 'undefined'
      ? localStorage.getItem('saved-language') || navigator.language.split('-')[0] || 'en'
      : 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
});

// Synchronize language changes between app and library i18n instances
// This ensures library components use the same language as the app
i18n.on('languageChanged', (lng) => {
  libraryI18n.changeLanguage(lng);
});

export default i18n;
